import React from "react";
import {
  Wrench, ShoppingCart, FolderKanban, Users, LayoutDashboard,
  // T2/100A67: sin Bookmark (pestaña Marcadores retirada).
  Handshake, Settings2, ClipboardList, Building2, Receipt, Calculator,
  ShoppingBasket,
  // T2/100A96
  Drill,
} from "lucide-react";
import {
  configModules, serviciosModules, talentoHumanoModules,
  purchasesModules, project, ventasModules, gerenciaModules,
  cotizacionesBaseModules, clientesModules, administrativoModules, solicitudesModules,
  gestionComprasModules,
  // T2/100A96: herramientasModules. T2/100A98: retirado (Herramientas va dentro de Compras).
} from "./modules";

// Sidebar layout. `group` is where the tab sits; a tab is shown by
// home/menu.js (any gated tile visible, or `always`).
export const TABS = [
  { key: "comercial", group: "main", name: "Comercial", icon: <Handshake size={16}/>, modules: ventasModules },
  { key: "servicios", group: "main", name: "Servicios", icon: <Wrench size={16}/>, modules: serviciosModules },
  { key: "proyectos", group: "main", name: "Proyectos", icon: <FolderKanban size={16}/>, modules: project },
  // T2/100A96: Compras original retirado del menú; se trabaja con el módulo nuevo. Antes:
  // { key: "compras", group: "main", name: "Compras", icon: <ShoppingCart size={16}/>, modules: purchasesModules },
  // T2/100A01: Pestaña nueva Gestion Compras, paralela a Compras (que no cambia).
  // T2/100A96: ahora es la pestaña "Compras" (clave "compras"). Antes:
  // { key: "gestion-compras", group: "main", name: "Gestion Compras", icon: <ShoppingBasket size={16}/>, modules: gestionComprasModules },
  { key: "compras", group: "main", name: "Compras", icon: <ShoppingBasket size={16}/>, modules: gestionComprasModules },
  // T2/100A96: Herramientas, pestaña propia (fuera de Compras).
  // T2/100A98: retirada; Herramientas es submódulo de Compras y la asignación está en Talento Humano. Antes:
  // { key: "herramientas", group: "main", name: "Herramientas", icon: <Drill size={16}/>, modules: herramientasModules },
  { key: "talento", group: "main", name: "Talento Humano", icon: <Users size={16}/>, modules: talentoHumanoModules },
  { key: "administrativo", group: "main", name: "Administrativo", icon: <Calculator size={16}/>, modules: administrativoModules, always: true },
  { key: "gerencia", group: "main", name: "Gerencia", icon: <LayoutDashboard size={16}/>, modules: gerenciaModules },
  { key: "clientes", group: "global", name: "Clientes", icon: <Building2 size={16}/>, modules: clientesModules, isGlobal: true },
  // T2/100A184: nombre en el menú global "Solicitudes de casos" (usuario 2026-10-29). Antes: name: "Solicitudes".
  { key: "solicitudes", group: "global", name: "Solicitudes de casos", icon: <ClipboardList size={16}/>, modules: solicitudesModules, isGlobal: true, always: true },
  { key: "cotizaciones", group: "global", name: "Cotizaciones", icon: <Receipt size={16}/>, modules: cotizacionesBaseModules, isGlobal: true, always: true },
  // T2/100A67: pestaña Marcadores retirada para todos (decisión del usuario). Antes:
  // { key: "marcadores", group: "bottom", name: "Marcadores", icon: <Bookmark size={16}/>, modules: [], isBottom: true, always: true },
  { key: "config", group: "bottom", name: "Configuraciones", icon: <Settings2 size={16}/>, modules: configModules, isBottom: true },
];
